export default {"src":"/_next/static/media/home-bg.0caf3210.svg","height":677,"width":2127,"blurWidth":0,"blurHeight":0};